import { useExamLocationRequestListSearchParams } from '../../hooks';
import { DraftExamLocationRequestList } from '../draft-exam-location-request-list';
import { InReviewExamLocationRequestList } from '../in-review-exam-location-request-list';
import { RejectedExamLocationRequestList } from '../rejected-exam-location-request-list';

export default function ProctorRequestList() {
  const [{ status }] = useExamLocationRequestListSearchParams();

  switch (status) {
    case 'IN_REVIEW':
      return <InReviewExamLocationRequestList />;
    case 'REJECTED':
      return <RejectedExamLocationRequestList />;
    case 'DRAFT':
      return <DraftExamLocationRequestList />;
    default:
      return null;
  }
}
